import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HelperService } from 'app/shared/services/global/helper.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-compare-calculator',
  templateUrl: './compare-calculator.component.html',
})
export class CompareCalculatorComponent implements OnInit {
  fieldDisable: boolean = false;
  modalRef: BsModalRef;
  age: any = null;
  income: any = null;
  deduction: any = null;
  oldTax: any = null;
  newTax: any = null;
  remainIncome: number;
  incomeAfterDeduction: any;

  constructor(
    public modalService: BsModalService,
    public sHelper: HelperService) { }

  ngOnInit() {
  }
  closeCompareCalculator() {
    this.modalService.hide(1);
  }
  calculateTax() {
    this.newTax = 0;
    this.oldTax = 0;
    this.fieldDisable = true;
    this.incomeAfterDeduction = this.income - this.sHelper.getZeroIfNull(this.deduction);
    if (this.income > 500000) {
      if (this.incomeAfterDeduction > 500000) {
        if (this.age == 'b60') {
          this.calculateOldTax();
        } else if (this.age == 'btw60') {
          this.calculateOldTax();
        } else if (this.age == 'a79') {
          this.calculateOldTax();
        }
      }
      this.calculateNewTax();
      this.calculateEducationCess();
      this.newTax=Math.round(this.newTax);
      this.oldTax=Math.round(this.oldTax);
    }
  }
  calculateEducationCess() {
    var eduTaxWithOld = this.oldTax * (0.04);
    this.oldTax = this.oldTax + eduTaxWithOld;

    var eduTaxNew = this.newTax * (0.04);
    this.newTax = this.newTax + eduTaxNew;
  }

  calculatePer(percent: number, income: number, regime: string) {

    const amount = income * (percent / 100);
    if (regime == 'new') {
      this.newTax = this.sHelper.getZeroIfNull(this.newTax) + amount;
    } else {
      this.oldTax = this.sHelper.getZeroIfNull(this.oldTax) + amount;
    }

  }

  calculateOldTax() {
    debugger

    var taxableSlab = 250000;
    if (this.age == 'b60') {
      taxableSlab = 250000;
    } else if (this.age == 'btw60') {
      taxableSlab = 300000;
    } else {
      taxableSlab = 500000;
    }
    if (this.age == 'btw60') {
    this.remainIncome = this.incomeAfterDeduction - taxableSlab;
    taxableSlab=200000;
    }else{
       this.remainIncome = this.incomeAfterDeduction - taxableSlab;
    }
    if (this.age != 'a79') {
      if (this.remainIncome > 0) {
        if (this.remainIncome >= taxableSlab) {
          this.calculatePer(5, taxableSlab, 'old');
        } else {
          this.calculatePer(5, this.remainIncome, 'old');
        }
        this.remainIncome = this.remainIncome - taxableSlab;
        taxableSlab = 500000;
      }
    }
    if (this.remainIncome > 0) {
      if (this.remainIncome >= 500000) {
        this.calculatePer(20, taxableSlab, 'old');
      } else {
        this.calculatePer(20, this.remainIncome, 'old');
      }
      this.remainIncome = this.remainIncome - 500000;
    } if (this.remainIncome > 0) {
      this.calculatePer(30, this.remainIncome, 'old');
    }

  }

  calculateNewTax() {
    this.remainIncome = this.income - 250000;
    var taxableSlab = 250000;
    if (this.remainIncome > 0) {
      if (this.remainIncome >= 250000) {
        this.calculatePer(5, taxableSlab, 'new');
      } else {
        this.calculatePer(5, this.remainIncome, 'new');
      }
      this.remainIncome = this.remainIncome - 250000;
    } if (this.remainIncome > 0) {
      if (this.remainIncome >= 250000) {
        this.calculatePer(10, taxableSlab, 'new');
      } else {
        this.calculatePer(10, this.remainIncome, 'new');
      }
      this.remainIncome = this.remainIncome - 250000;
    } if (this.remainIncome > 0) {
      if (this.remainIncome >= 250000) {
        this.calculatePer(15, taxableSlab, 'new');
      } else {
        this.calculatePer(15, this.remainIncome, 'new');
      }
      this.remainIncome = this.remainIncome - 250000;
    }
    if (this.remainIncome > 0) {
      if (this.remainIncome >= 250000) {
        this.calculatePer(20, taxableSlab, 'new');
      } else {
        this.calculatePer(20, this.remainIncome, 'new');
      }
      this.remainIncome = this.remainIncome - 250000;
    } if (this.remainIncome > 0) {
      if (this.remainIncome >= 250000) {
        this.calculatePer(25, taxableSlab, 'new');
      } else {
        this.calculatePer(25, this.remainIncome, 'new');
      }
      this.remainIncome = this.remainIncome - 250000;
    }
    if (this.remainIncome > 0) {
      this.calculatePer(30, this.remainIncome, 'new');
    }

  }



}
